export const APPLICATION_ABBREVIATION = 'HSH'
export const APPLICATION_TITLE = 'Haunted Space Hotel'

export const RESEARCH = 'Research';
export const LODGING = 'Lodging';
export const ROBOT = 'Robot';
export const RENOVATION = 'Renovation';
export const ADVERTISEMENT = 'Advertisement';
export const GHOST = 'Ghost';

export const GUEST = 'Guest';
export const PIRATE = 'Pirate';
export const ENVOY = 'Envoy';
export const SEEKER = 'Seeker';

export const OBSERVATORY = 'Observatory';
export const CASINO = 'Casino';
export const ARENA = 'Arena';
export const BAR = 'Bar';
export const ALTAR = 'Altar';
export const ZOO = 'Zoo';

export const ACTION = 'Action';
export const BED = 'Bed';
export const RANDOM = 'Random';
export const WEAKNESS = 'Weakness';
export const AMENITY = 'Amenity';

export const ACTION_PLUS = 'Action Plus'

export const INITIAL = 'Initial';
export const WAIT = 'Wait';
export const TURN = 'Turn';
export const SCORE = 'Score';

export const OFF = 'Off';
export const START = 'Start';
export const PRE_RANDOM = 'PreRandom';
export const CHOOSE_ACTIONS = 'ChooseActions';
export const SELECT_ACTION = 'SelectAction';
export const EXECUTE_ACTION = 'ExecuteAction';
export const POST_RANDOM = 'PostRandom';
export const END_TURN = 'EndTurn';
export const DEFENCE = 'Defence';

export const ACTION_IDS = [1, 2, 3, 4, 5, 6];
export const ACTION_NAMES = [
    null, RESEARCH, LODGING, 'Staff', RENOVATION, ADVERTISEMENT, GHOST];

export const ACTIONS = {};
ACTIONS.RESEARCH_ID = 1;
ACTIONS.LODGING_ID = 2;
ACTIONS.ROBOT_ID = 3;
ACTIONS.RENOVATION_ID = 4;
ACTIONS.ADVERTISEMENT_ID = 5;
ACTIONS.GHOST_ID = 6;

export const ACTION_ROOM_NAMES = [
    RESEARCH, LODGING, 'Staff', RENOVATION, ADVERTISEMENT, GHOST];
export const WEAKNESS_IDS = [3, 4, 5, 0, 1, 2];
export const DEFAULT_HEX_RADIUS = 0.5;
export const DEFAULT_HEX_HEIGHT = 0.1;
export const NEIGHBOR_AXIAL_COORDINATES_CLOCKWISE = [
    [0, -1, 1],
    [-1, 0, 1],
    [-1, 1, 0],
    [0, 1, -1],
    [1, 0, -1],
    [1, -1, 0],
];

export const DEEP = 'Deep';
export const STEM = 'Stem';
export const HEX = 'Hex';
export const DREAD = 'Dread';
export const HONORED = 'Honored';
export const SEED = 'Seed';

export const FACTION_NAMES = [
    DEEP, STEM, HEX, DREAD, HONORED, SEED];

export const AMENITY_NAMES = [
    OBSERVATORY, CASINO, ARENA, BAR, ALTAR, ZOO];

export const BED_NAMES = [
    DEEP, STEM, HEX, DREAD, HONORED, SEED];


export const NEIGHBOR_AXIAL_COORDINATES = [
    [0, -1, 1],
    [1, -1, 0],
    [1, 0, -1],
    [0, 1, -1],
    [-1, 1, 0],
    [-1, 0, 1],
];


export const STARTING = 'Starting';
export const STARTED = 'Started';
export const TAKING_TURNS = 'Taking Turns';
export const SCORING = 'Scoring';
export const WIN = 'Win';
export const SAVING = 'Saving';
export const ROUND_SETUP = 'Round Setup';
export const GHOST_STARTER = 'Ghost Starter';
export const DRAFT = 'Draft';
export const ERROR = 'ERROR';
export const GAME_LOADED = 'Game Loaded';
export const PLAYER_LOADED = 'Player Loaded';
export const TAKING_TURN = 'Taking Turn';
export const WAITING = 'Waiting';

export const WHEEL_NUMBERS = [0, 1, 1, 1, 0, 2]
export const WHEEL_CHOICES = [[1, 1], [1, 2], [2, 2], [2, 3], [3, 3],
        [3, 4], [4, 4], [5, 4], [5, 6], [6, 1]]

export const CARD_TEXTURES = [null,
    84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100,
    101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114,
    115, 116, 117, 118, 119, 120, 121];


export const GamePlayerStatus = {
    STARTING: 'Starting',
    STARTING_ID: 1,
    STARTED: 'Started',
    STARTED_ID: 2,
    TAKING_TURNS: 'Taking Turns',
    TAKING_TURNS_ID: 3,
    SCORING: 'Scoring',
    SCORING_ID: 4,
    WIN: 'Win',
    WIN_ID: 5,
    SAVING: 'Saving',
    SAVING_ID: 6,
    ROUND_SETUP: 'Round Setup',
    ROUND_SETUP_ID: 7,
    GHOST_STARTER: 'Ghost Starter',
    GHOST_STARTER_ID: 8,
    DRAFT: 'Draft',
    DRAFT_ID: 9,  // not used.
    ERROR: 'ERROR',
    ERROR_ID: 10,
    GAME_LOADED: 'Game Loaded',
    GAME_LOADED_ID: 11,
    PLAYER_LOADED: 'Player Loaded',
    PLAYER_LOADED_ID: 12,
    TAKING_TURN: 'Taking Turn',
    TAKING_TURN_ID: 13,
    WAITING: 'Waiting',
    WAITING_ID: 14,
    DEFENDING: 'Defending',
    DEFENDING_ID: 15,
    GHOSTED: 'Ghosted',
    GHOSTED_ID: 16,
    PICK_DRAFT: 'Pick Draft',
    PICK_DRAFT_ID: 17,
    RESEARCHING: 'Researching',
    RESEARCHING_ID: 18,
    LODGING: 'Lodging',
    LODGING_ID: 19,
    ROBOTING: 'Roboting',
    ROBOTING_ID: 20,
    RENOVATING: 'Renovating',
    RENOVATING_ID: 21,
    ADVERTISING: 'Advertising',
    ADVERTISING_ID: 22,
    GHOSTING: 'Ghosting',
    GHOSTING_ID: 23,
    SPECIAL: 'Special',
    SPECIAL_ID: 24,
    GAME_SETUP: 'Game Setup',
    GAME_SETUP_ID: 25,
    PICK_PLAYER_ONE: 'Pick Player One',
    PICK_PLAYER_ONE_ID: 26,
    PICK_FACTION: 'Pick Faction',
    PICK_FACTION_ID: 27,
    PICK_STATION: 'Pick Station',
    PICK_STATION_ID: 28,
    RANDOM: 'Random',
    RANDOM_ID: 29,
    GAME_OVER: 'Game Over',
    GAME_OVER_ID: 30,
    TIED: 'Tied',
    TIED_ID: 31,
    // Manual 3.1 opening ghost placement (engine: see
    // games/models.GamePlayerStatus.OPENING_GHOST_PLACEMENT_ID).
    OPENING_GHOST_PLACEMENT: 'Opening Ghost Placement',
    OPENING_GHOST_PLACEMENT_ID: 32,
    // Manual §3 in-game faction selection (engine: see
    // games/models.GamePlayerStatus.CHOOSE_FACTION_ID).
    CHOOSE_FACTION: 'Choose Faction',
    CHOOSE_FACTION_ID: 33,
    ACTION_IDS: [ 18, 19, 20, 21, 22, 36, 29 ],
}
export const GamePlayerStatusLookup = Object.fromEntries(Object.entries(GamePlayerStatus).map(a => a.reverse()));


export const TurnStatus = {
    OFF: OFF,
    OFF_ID: 1,
    START: START,
    START_ID: 2,
    PRE_RANDOM: PRE_RANDOM,
    PRE_RANDOM_ID: 3,
    CHOOSE_ACTIONS: CHOOSE_ACTIONS,
    CHOOSE_ACTIONS_ID: 4,
    SELECT_ACTION: SELECT_ACTION,
    SELECT_ACTION_ID: 5,
    EXECUTE_ACTION: EXECUTE_ACTION,
    EXECUTE_ACTION_ID: 6,
    POST_RANDOM: POST_RANDOM,
    POST_RANDOM_ID: 7,
    END_TURN: END_TURN,
    END_TURN_ID: 8,
    LOCKED: 'Locked',
    LOCKED_ID: 9,
    ACTION_COMPLETE: 'Action Complete',
    ACTION_COMPLETE_ID: 10,
}
export const TurnStatusLookup = Object.fromEntries(Object.entries(TurnStatus).map(a => a.reverse()));


export const ActionStatus = {
    INIT_ID: 1,
    WAIT_ID: 2,
    JUICE_ID: 3,
    WAIT_FOR_JUICE: 4,
    ATTACK_ID: 5,
    REMOVE_ID: 6,
    ADD_ID: 7,
    DONE_ID: 8,
    ATTACKING_ID: 9,
    SPECIAL_ID: 10,
    FATE_MINIGAME_ID: 11,
    FATE_MINIGAME_DONE_ID: 12,
    RANDOM_MINIGAME_ID: 13,
    RANDOM_MINIGAME_DONE_ID: 14,
    WAIT_FOR_TARGET_ID: 15,
}
export const ActionStatusLookup = Object.fromEntries(Object.entries(ActionStatus).map(a => a.reverse()));


export const Room = {};
Room.ADVANCED_ROBOT_ROOM_ID = 5;
Room.RANDOM_ACTION_ROOM_ID = 55;
Room.DEBRIS_ID = 56;
Room.FIRST_WEAKNESS_ID = 49;
Room.PLAIN_UPGRADED_BED = 57;
Room.UNUPGRADED_PLAIN_BED = 58;
Room.PLAIN_BEDS = [ 57, 58 ];
Room.BED_IDS = [ 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 57, 58 ];
Room.UPGRADED_BED_IDS = [ 25, 27, 29, 31, 33, 35, 57 ];
Room.UNUPGRADED_BED_IDS = [ 26, 28, 30, 32, 34, 36, 58 ];
Room.UPGRADED_FACTION_BED_IDS = [ 25, 27, 29, 31, 33, 35 ];
Room.UNUPGRADED_FACTION_BED_IDS = [ 26, 28, 30, 32, 34, 36 ];
Room.FACTION_BEDS = [ ...Room.UPGRADED_FACTION_BED_IDS, ...Room.UNUPGRADED_FACTION_BED_IDS ];
Room.ARENA_ID = 18;
Room.AMENITY_IDS = [ 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24 ];
Room.UPGRADED_AMENITY_IDS = [ 13, 15, 17, 19, 21, 23 ];
Room.UNUPGRADED_AMENITY_IDS = [ 14, 16, 18, 20, 22, 24 ];
Room.LODGING_IDS = [ 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48 ];
Room.LODGING_FACTIONS = [ 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6 ];
Room.UPGRADED_LODGING_IDS = [ 37, 39, 41, 43, 45, 47 ];
Room.UNUPGRADED_LODGING_IDS = [ 38, 40, 42, 44, 46, 48 ];
Room.ROBOTS_REQUIRED = [ null,
    1, 2, 1, 2, 1, 2,
    1, 2, 1, 2, 1, 2,
    1, 2, 1, 2, 1, 2,
    1, 2, 1, 2, 1, 2,
    1, 2, 1, 2, 1, 2,
    1, 2, 1, 2, 1, 2,
    -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1,
    3, 3, 3, 3, 3, 3,
    1, 0, 1, 2 ];
Room.WEAKNESS_ROOMS = [ 49, 50, 51, 52, 53, 54 ];
Room.BUILT_IN_ROOMS = [ 49, 50, 51, 52, 53, 54, 55 ];

Room.ACTION_ROOMS = [ 1, 2, 3, 4, 5, 6,
    7, 8, 9, 10, 11, 12,
    49, 50, 51, 52, 53, 54 ];
Room.ACTION_ROOM_ACTIONS = [ 1, 1, 2, 2, 3, 3,
    4, 4, 5, 5, 6, 6,
    1, 2, 3, 4, 5, 6 ];
Room.UPGRADED_ACTION_ROOMS = [ 1, 3, 5, 7, 9, 11 ];
Room.UNUPGRADED_ACTION_ROOMS = [ 2, 4, 6, 8, 10, 12 ];
Room.ACTION_ROOMS_WITH_RANDOM = [ 1, 7, 55 ];

Room.FACTION_ACTIONS_BY_FACTION = [ 59, 60, 61, 62, 63, 64 ];

Room.RESEARCH_ACTION_ROOMS = [ 1, 2, 49 ];
Room.LODGING_ACTION_ROOMS = [ 3, 4, 50 ];
Room.ROBOT_ACTION_ROOMS = [ 5, 6, 51 ];
Room.RENOVATION_ACTION_ROOMS = [ 7, 8, 52 ];
Room.ADVERTISEMENT_ACTION_ROOMS = [ 9, 10, 53 ];
Room.GHOST_ACTION_ROOMS = [ 11, 12, 54 ];
Room.ACTION_ROOM_TYPES = [
    null,
    Room.RESEARCH_ACTION_ROOMS,
    Room.LODGING_ACTION_ROOMS,
    Room.ROBOT_ACTION_ROOMS,
    Room.RENOVATION_ACTION_ROOMS,
    Room.ADVERTISEMENT_ACTION_ROOMS,
    Room.GHOST_ACTION_ROOMS,
];
Room.UNUPGRADED_STATION_ROOMS = [
    ...Room.UNUPGRADED_BED_IDS,
    ...Room.UNUPGRADED_AMENITY_IDS,
    ...Room.UNUPGRADED_ACTION_ROOMS,
];
Room.UPGRADED_STATION_ROOMS = [
    ...Room.UPGRADED_BED_IDS,
    ...Room.UPGRADED_AMENITY_IDS,
    ...Room.UPGRADED_ACTION_ROOMS,
];
Room.NAMES = [ null, 'Upgraded Action Room Research', 'Action Room Research',
    'Upgraded Action Room Lodging', 'Action Room Lodging',
    'Upgraded Action Room Staff', 'Action Room Staff',
    'Upgraded Action Room Renovation', 'Action Room Renovation',
    'Upgraded Action Room Advertisement', 'Action Room Advertisement',
    'Upgraded Action Room Ghost', 'Action Room Ghost',
    'Upgraded Amenity Room Observatory', 'Amenity Room Observatory',
    'Upgraded Amenity Room Casino', 'Amenity Room Casino',
    'Upgraded Amenity Room Arena', 'Amenity Room Arena',
    'Upgraded Amenity Room Bar', 'Amenity Room Bar',
    'Upgraded Amenity Room Altar', 'Amenity Room Altar',
    'Upgraded Amenity Room Zoo', 'Amenity Room Zoo',
    'Upgraded Bed Room Deep', 'Bed Room Deep',
    'Upgraded Bed Room Stem', 'Bed Room Stem', 'Upgraded Bed Room Hex',
    'Bed Room Hex', 'Upgraded Bed Room Dread', 'Bed Room Dread',
    'Upgraded Bed Room Honored', 'Bed Room Honored',
    'Upgraded Bed Room Seed', 'Bed Room Seed',
    'Upgraded Lodging Room Deep', 'Lodging Room Deep',
    'Upgraded Lodging Room Stem', 'Lodging Room Stem',
    'Upgraded Lodging Room Hex', 'Lodging Room Hex',
    'Upgraded Lodging Room Dread', 'Lodging Room Dread',
    'Upgraded Lodging Room Honored', 'Lodging Room Honored',
    'Upgraded Lodging Room Seed', 'Lodging Room Seed',
    'Dread  Weakness Room', 'Honored  Weakness Room',
    'Seed  Weakness Room', 'Deep Weakness Room', 'Stem  Weakness Room',
    'Hex  Weakness Room', 'Random Room', 'Debris',
    'Upgraded Plain Bed Room', 'Plain Bed Room' ];

export const PERMANENT_STAFF = [1, 2];
export const STARTING_STAFF_POOL = [3, 4, 5, 6, 7, 8];

export const FACTION_BS_VARIANT = [
    null, 'deep', 'stem', 'hex', 'dread', 'honored', 'seed'
];
export const FACTION_CSS_COLORS = [
    null, 'var(--deep)', 'var(--stem)', 'var(--hex)', 'var(--dread)', 'var(--honored)', 'var(--seed)'
];

export const Texture = {}
Texture.ROBOT_ACTION = 73;
Texture.GHOST_ACTION = 76;
Texture.ACTIONS = [null, 71, 72, 73, 74, 75, 76, 83]
Texture.NAMES = [
    null,
    'Upgraded Action Room Research', 'Action Room Research',
    'Upgraded Action Room Lodging', 'Action Room Lodging',
    'Upgraded Action Room Robot', 'Action Room Robot',
    'Upgraded Action Room Renovation', 'Action Room Renovation',
    'Upgraded Action Room Advertisement', 'Action Room Advertisement',
    'Upgraded Action Room Ghost', 'Action Room Ghost',
    'Upgraded Amenity Room Observatory', 'Amenity Room Observatory',
    'Upgraded Amenity Room Casino', 'Amenity Room Casino',
    'Upgraded Amenity Room Arena', 'Amenity Room Arena',
    'Upgraded Amenity Room Bar', 'Amenity Room Bar',
    'Upgraded Amenity Room Altar', 'Amenity Room Altar',
    'Upgraded Amenity Room Zoo', 'Amenity Room Zoo',
    'Upgraded Bed Room Deep', 'Bed Room Deep', 'Upgraded Bed Room Stem',
    'Bed Room Stem', 'Upgraded Bed Room Hex', 'Bed Room Hex',
    'Upgraded Bed Room Dread', 'Bed Room Dread',
    'Upgraded Bed Room Honored', 'Bed Room Honored',
    'Upgraded Bed Room Seed', 'Bed Room Seed', 'Upgraded Lodging Room Deep',
    'Lodging Room Deep', 'Upgraded Lodging Room Stem', 'Lodging Room Stem',
    'Upgraded Lodging Room Hex', 'Lodging Room Hex',
    'Upgraded Lodging Room Dread', 'Lodging Room Dread',
    'Upgraded Lodging Room Honored', 'Lodging Room Honored',
    'Upgraded Lodging Room Seed', 'Lodging Room Seed',
    'Dread Weakness Room Research', 'Honored Weakness Room Lodging',
    'Seed Weakness Room Robots', 'Deep Weakness Room Renovation',
    'Stem Weakness Room Advertisement', 'Hex Weakness Room Ghost',
    'Random Room', 'Debris', 'Upgraded Plain Bed Room', 'Plain Bed Room',
    'Faction Action Deep', 'Faction Action Stem',
    'Faction Action Hex', 'Faction Action Dread',
    'Faction Action Honored', 'Faction Action Seed',
    'Faction Action Research', 'Faction Action Lodging',
    'Faction Action Robot', 'Faction Action Renovation',
    'Faction Action Advertisement', 'Faction Action Ghost',
    'Action Research', 'Action Lodging', 'Action Robot',
    'Action Renovation', 'Action Advertisement',
    'Action Ghost', 'Faction Selector Deep', 'Faction Selector Stem',
    'Faction Selector Hex', 'Faction Selector Dread',
    'Faction Selector Honored', 'Faction Selector Seed',
    'Random Action Selector', 'Deep Guest Observatory', 'Deep Vanguard Casino',
    'Deep Guest Arena', 'Deep Pirate Bar', 'Deep Guest Altar',
    'Deep Seeker Zoo', 'Stem Guest Observatory', 'Stem Vanguard Casino',
    'Stem Guest Arena', 'Stem Pirate Bar', 'Stem Guest Altar',
    'Stem Seeker Zoo', 'Hex Guest Observatory', 'Hex Vanguard Casino',
    'Hex Guest Arena', 'Hex Pirate Bar', 'Hex Guest Altar',
    'Hex Seeker Zoo', 'Dread Guest Observatory', 'Dread Vanguard Casino',
    'Dread Guest Arena', 'Dread Pirate Bar', 'Dread Guest Altar',
    'Dread Seeker Zoo', 'Honored Guest Observatory', 'Honored Vanguard Casino',
    'Honored Guest Arena', 'Honored Pirate Bar', 'Honored Guest Altar',
    'Honored Seeker Zoo', 'Seed Guest Observatory', 'Seed Vanguard Casino',
    'Seed Guest Arena', 'Seed Pirate Bar', 'Seed Guest Altar',
    'Seed Seeker Zoo', 'Upgraded Ghost Card', 'Ghost Card', 'Ghost Wheel',
    'Lodging Wheel', 'Pirate Wheel', 'Action Hex', 'One Snohe',
    'Three Snohe', 'Five Snohe', 'Ten Snohe', 'Relic', 'Chest', 'Vendor',
    'Mystery', 'Boss', 'Competition', 'Bank', 'DeepCaptain', 'StemCaptain',
    'HexCaptain', 'DreadCaptain', 'HonoredCaptain', 'SeedCaptain', 'Staff',
    'Executive', 'Section Lead', 'Department Head', 'CEO', 'Partner',
    'Relic Junk Quality', 'Relic Common Quality', 'Relic Rare Quality',
    'Relic Exotic Quality', 'Relic Epic Quality', 'Relic Legendary Quality',
    'Not', 'Fate', 'HexBot', 'Deep Hotel Card', 'Stem Hotel Card',
    'Hex Hotel Card', 'Dread Hotel Card', 'Honored Hotel Card',
    'Seed Hotel Card', 'Ghost Wave', 'Draft', 'Actions', 'Snohe',
    'Deep Freighter', 'Stem Freighter', 'Hex Freighter', 'Dread Freighter',
    'Honored Freighter', 'Seed Freighter', 'Deep Refugee', 'Stem Refugee',
    'Hex Refugee', 'Dread Refugee', 'Honored Refugee', 'Seed Refugee',
    'Deep Aristocrat', 'Stem Aristocrat', 'Hex Aristocrat',
    'Dread Aristocrat', 'Honored Aristocrat', 'Seed Aristocrat',
    'Deep Crowd', 'Stem Crowd', 'Hex Crowd', 'Dread Crowd', 'Honored Crowd',
    'Seed Crowd', 'Deep Freelancer', 'Stem Freelancer', 'Hex Freelancer',
    'Dread Freelancer', 'Honored Freelancer', 'Seed Freelancer'];


export const ACTION_HEX_POSITION_ACTIONS = [
    [1, 1], [6, 1],
    [6, 6], [5, 6],
    [5, 5], [4, 5],
    [4, 4], [3, 4],
    [3, 3], [3, 2],
    [2, 2], [1, 2]
];
// rotating the action hex clockwise
export const ACTION_HEX_FULL_ACTION_POSITIONS = [0, 10, 8, 6, 4, 2];
export const ACTION_HEX_FULL_ACTION_KEYS = [1, 2, 3, 4, 5, 6];




